<template>
  <AccountIconWh24 :image-url="imageUrl" />
</template>

<script>
import profile from '../../../../images/styleguide/IMG_1809.png'
import AccountIconWh24 from '../../components/atoms/account_icons/AccountIconWh24.vue'
export default {
  components: { AccountIconWh24 },
  data() {
    return {
      imageUrl: ''
    }
  },
  mounted() {
    this.imageUrl = profile
  }
}
</script>
